import { delay, HttpResponse } from "msw";
import { MESSAGES_MOCKED } from "./constMessages";

// @ts-ignore
export const getMessages = async ({ params }) => {
  await delay("real");

  return HttpResponse.json({
    messages: MESSAGES_MOCKED[params.chat_id],
  });
};
